import {loggedOutSegment, segment} from './helpers'

export const viewedHtoVideo = () => {
  segment('HTO LP Video clicked')
  // replace ^ with below line when we're ready to combine events
  // viewedVideo('Home Try-On', 'HTO LP')
}

export const clickedHtoLink = (eventName, targetLinkName) => segment(eventName, {targetLinkName})

export const clickedHtoProduct = (product) => loggedOutSegment('HTO LP Product Clicked', {product})
